import React from 'react';
import '../styles/videos.css';

interface VideoItem {
  id: string;
  title: string;
  description: string;
  embedUrl: string;
}

const videos: VideoItem[] = [
  {
    id: 'video1',
    title: 'Letting AI Build My Witch Hunter in Path of Exile 2',
    description: ' I let my custom AI make EVERY decision for my Witch Hunter build, from skills to passives. Did it shine as a strategic guide or fumble under pressure?',
    embedUrl: 'https://www.youtube.com/embed/9ASZykFrcKk?si=vt3XtLNfd6CZqJv9erometer'
  },

  {
    id: 'video2',
    title: 'Letting AI Build My Witch Hunter for POE2 II',
    description: ' I let my custom AI make EVERY decision for my Witch Hunter build, from skills to passives. Did it shine as a strategic guide or fumble under pressure?',
    embedUrl: 'https://www.youtube.com/embed/1SVux0LKhks?si=ch9FlXo9jrWB1pDR'
  },
  {
    id: 'video3',
    title: 'Letting AI Build My Witch Hunter for POE2 II - Part3',
    description: ' In this video, I have introduced the new feature about my PoE2 Skills Planner, and talking about the trainning of the AI chatbot to give the user better advise.  Moreover, we keep playing the Witch Hunter and let AI to make every major decision for us. If you like the AI planner please check it out at https://poe2skills-ai.com/',
    embedUrl: 'https://www.youtube.com/embed/FxtITH3NVv4?si=kPS92bfK2_uDsDdx'
  },
  {
    id: 'video4',
    title: 'How I and my friend defeat Count Geonor, the Putrid Wolf',
    description: 'This is the video that my friend and I defeat the Count Geonor, the Putrid Wolf. Of course that the charater that I use is the mercessary I built with suggestion with my AI advisor. If you are also interested about the game or what to find some handy guide for POE2 welcome to access my website.https://poe2skills-ai.com/ ',
    embedUrl: 'https://www.youtube.com/embed/C5LjoAV3_U4?si=3QYsGePY3BNo8Gqn'
  },
  // Add more videos here
];

export const VideosPage: React.FC = () => {
  return (
    <div className="videos-container">
      <h1>PoE2 Vlog</h1>
      <div className="videos-grid">
        {videos.map((video) => (
          <div key={video.id} className="video-card">
            <div className="video-wrapper">
              <iframe
                width="560" 
                height="315"
                src={video.embedUrl}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <h2>{video.title}</h2>
            <p>{video.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}; 